module.exports = __webpack_public_path__ + "static/media/logo.74052802.svg";